import { Faq16, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './RateInfo.css';
import { CommonRateIndicator } from './parts/CommonRateIndicator';

export interface IRateInfoProps {
  onInfoIconClick: () => void;
  rate: number;
  rateText: string;
}

export const RateInfo: React.FC<IRateInfoProps> = ({ onInfoIconClick, rate, rateText }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['text']}>
        <UIText2 fontWeight="bold">Оценка от дептранса</UIText2>
        <div className={styles['info-icon']} role="button" onClick={onInfoIconClick} data-testid="RateInfoIcon">
          <Faq16 color="primary_100" />
        </div>
        <div className={styles['rate']}>{rateText}</div>
      </div>
      <CommonRateIndicator rate={rate} />
    </div>
  );
};
